import labels from './labels';

export default {
  settings: {
    languageId: 'en-US',
    currencyId: 'USD',
    environment: 'QA',
    currencySymbol: '$',
    tokenSource: 'uim',
    isActualWorkflow: false,
    isCollapsibleMode: true,
    showAdvisoryFee: true,
    showTransactionFee: true,
    showPlanFee: true,
    showAnnualAccountFee: true,
    showAnnualAssetBaseFee: true,
    showAnnualFeeFrequency: true,
    showPayFeeMethod: true,
    showPayFeeTime: true,
    showHoldingLevelFees: true,
    showPayCashFirst: true,
    showAnnuity: true,
    showLoiAsFrontLoad: false,
    showChargeForRebalancing: true,
    assetBasedFeeConfig: {
      allowAssetBasedFeePercent: true,
      allowAssetBasedFeeSchedule: true,
      allowAssetBasedMaxFee: true,
      maxFeeOrFeeScheduleSource: [0, 1], // 0: Administrator Created, 1: Normal User Created, 2: Data Collections
      alertAssetBasedFeeRequired: 1, // 0: off, 1: Require all holdings, 2: Require at least one holding
    },
    preference: {
      annualAccountFeeAmount: 0,
      annualFeeType: 1,
      annualFeeAmount: 0,
      annualFeeAmountType: 1,
      feeScheduleId: '',
      annualFeeChargeFrequency: 1,
      annualFeePayOnBegin: false,
      annualFeePayMethod: 1,
      annualFeePayCashFirst: true,
      discount: 0,
      frontLoadType: 1,
      frontLoadAmount: 0,
      frontLoadAmountType: 1,
      redemptionCharge: false,
      chargeOnRebalancing: false,
    },
    showInfoIcons: true,
    enableThreeReturns: false,
    enableFullscreenFeeScheduleModal: true,
  },
  components: {
    // eslint-disable-next-line prettier/prettier
    'fee-schedule-summary-list': {
      settings: {
        showInfoIcons: true,
        useExternalActiveStatus: true,
        isExternalUser: false,
      },
    },
  },
  labels: {
    en: labels['en-US'],
    fr: labels['fr-CA'],
    ...labels,
  },
};
